import Vue from 'vue'

import TimePicker from "@/components/Form/TimePicker.vue";
import DatePicker from "@/components/Form/DatePicker.vue";
import Infobulle from "@/components/Form/Infobulle.vue";
import Catalogue from "@/components/Form/Catalogue.vue";
import Memo from "@/components/Form/Memo.vue";
import CaseACocher from "@/components/Form/CaseACocher.vue";
import TextField from "@/components/Form/TextField.vue";
import FileInput from "@/components/Form/FileInput.vue";
import MultiFileInput from "@/components/Form/MultiFileInput.vue";
import Ressource from "@/components/Common/Ressource.vue";
import Loading from "@/components/Common/Loading.vue";
import Alert from "@/components/Common/Alert.vue";
import Logo from "@/components/Common/Logo.vue";
import DataIterator from "@/components/Form/DataIterator.vue";
import PageHeadline from "@/components/FormParts/PageHeadline.vue";
import SubHeadline from "@/components/FormParts/SubHeadline.vue";
import Relation from "@/components/Form/Relation.vue";
import BasicAppbar from "@/layouts/BasicAppbar.vue";

Vue.component("infobulle", Infobulle)
Vue.component("opq-date-picker", DatePicker)
Vue.component("opq-time-picker", TimePicker)
Vue.component("opq-catalogue", Catalogue)
Vue.component("opq-memo", Memo)
Vue.component("opq-case", CaseACocher)
Vue.component("opq-text-field", TextField)
Vue.component("opq-file", FileInput)
Vue.component("opq-file-multiple", MultiFileInput)
Vue.component("ressource", Ressource)
Vue.component("opq-loading", Loading)
Vue.component("opq-alert", Alert)
Vue.component("data-iterator", DataIterator)
Vue.component("headline", PageHeadline)
Vue.component("subheadline", SubHeadline)
Vue.component("opq-relation", Relation)
Vue.component("opq-logo", Logo)
Vue.component("opq-basic-appbar", BasicAppbar)

Vue.prototype.$emailRegex = /.+@.+\..+/
Vue.prototype.$dateRegex = /\d{4}-\d{2}-\d{2}/

const icons = {
  school: "mdi-school",
  cours: "mdi-human-greeting",
  expPro: "mdi-briefcase-clock",
  formationPratique: "mdi-briefcase-account",
  judiciaire: "mdi-scale-balance",
  job: 'mdi-briefcase',
  formationContinue: "mdi-notebook-multiple",
  recherche: "mdi-feature-search",
  services: "mdi-account-multiple",
  teacher: "mdi-human-male-board"
}

Vue.prototype.$getIcon = (key) => {
  return icons[key]
}
Vue.prototype.$valeursCatalogues = {
  adresseProfessionnelle: process.env.VUE_APP_AdresseProfessionnelle,
  infractionCriminelle: process.env.VUE_APP_InfractionCriminelle,
  decisionDisciplinaire: process.env.VUE_APP_DecisionDisciplinaire,
  infraction5ans: process.env.VUE_APP_Infraction5ans,
  responsabiliteProfessionnelle: process.env.VUE_APP_ResponsabiliteProfessionnelle
}